import { SERVICEURI } from "../const/serviceuri";
import moment from "moment";
import { postTelemetryApiInstance } from '../instance/fetchtelemetryapiInstance';
import { getFrameworkApiInstance, postFrameworkApiInstance } from '../instance/fetchframeworkapiInstance';
import helperfunctions from "../utils/helperfunctions";

const getMyFleetGridData = (filterCriteria?: any, top?: number, skip?: number, filterOrSortCriteria?: any, isFilter?: any, sortBy?: any, filterOrSort?: any, customfilter?: any) => {
    let custFilter = "";
    const updatedFilter = customfilter && customfilter?.length > 0 ? customfilter?.replace(/&/g, '%26'): '';
    if (filterOrSort == "filter") {
        custFilter = "&$filter=" + updatedFilter;
    } else if (filterOrSort == "sort") {
        custFilter = "&$orderby=" + updatedFilter;
    }

    let endPoint = SERVICEURI.getMyFleetListData;
    endPoint += "?$top=" + top + "&$skip=" + skip + custFilter;
    endPoint =
        filterOrSort == "sort"
            ? endPoint
            : AddFiltertoEndpoint(filterOrSortCriteria, endPoint, isFilter, custFilter);
    if (sortBy?.length > 0) {
        if (sortBy[0].field == "lmdt") {
            endPoint += `&$orderby=lmd ${sortBy[0].dir}`;
        } else if (sortBy[0].field == "locName") {
            endPoint += `&$orderby=loc ${sortBy[0].dir}`;
        } else if (sortBy[0].field && sortBy[0].dir) {
            endPoint += `&$orderby=${sortBy[0].field} ${sortBy[0].dir}`;
        }
    }
    const finalEndPoint = helperfunctions.replaceSecondFilter(endPoint)
    return postTelemetryApiInstance(finalEndPoint, filterCriteria);
}

const getMyFleetTitleData = (
    filterCriteria?: any,
    skip?: any,
    top?: any,
    filterOrSortCriteria?: any,
    isFilter?: any,
    filterOrSort?: any,
    customfilter?: any
) => {
    let endPoint = SERVICEURI.getTilesListMyFleet;
    let custFilter = "";
    const updatedFilter = customfilter ? customfilter.replace(/&/g, '%26'): '';
    if (filterOrSort == "filter") {
        if (filterOrSortCriteria != 'filter') {
            endPoint += isFilter && custFilter ? "&$filter=" + custFilter : "&$orderby=" + filterOrSortCriteria;
        } else if (filterOrSortCriteria == 'filter') {
            custFilter = "&$filter=" + updatedFilter;
        } else {
            custFilter = "&$orderby=" + updatedFilter;
        }
    } else if (filterOrSort == "sort") {
        custFilter = "&$orderby=" + updatedFilter;
    } else if (filterOrSortCriteria) {
        endPoint += isFilter ? "&$filter=" + filterOrSortCriteria : "&$orderby=" + filterOrSortCriteria;
    }
    if (skip >= 0 && top > 0) {
        endPoint += `?$skip=${skip}&$top=${top}${custFilter}`;
    }

    return postTelemetryApiInstance(endPoint, filterCriteria);
};

const getInfoWindowData = async (data: any) => {
    let endPoint = SERVICEURI.getInfoWindowData;

    let results = new Promise((onSucess, onFailure) => {
        postTelemetryApiInstance(endPoint, data).then(response => {
            onSucess(response);
        }).catch((error: any) => {
            onFailure(error);
        });
    });
    return await results;
}
const getMyFleetMapData = async (
    filterCriteria?: any,
    filterOrSortCriteria?: any,
    isFilter?: any,
    sortBy?: any,
    isCustomFilter?: boolean,
    filterOrSortMap?: any,
    customfilterMap?: any
) => {
    let endPoint = SERVICEURI.getMyFleetMapData;
    const updatedFilter = customfilterMap ? customfilterMap.replace(/&/g, '%26'): '';

    if (filterOrSortMap == 'filter') {
        endPoint += "?$filter=" + updatedFilter
    } else if (filterOrSortMap == 'sort') {
        endPoint += "?$orderby=" + updatedFilter
    } else if (filterOrSortCriteria) {
        endPoint += isFilter ? '?$filter=' + filterOrSortCriteria : '?$orderby=' + filterOrSortCriteria;
    }

    let results = await new Promise((onSucess, onFailure) => {
        postTelemetryApiInstance(endPoint, filterCriteria)
            .then((response) => {
                onSucess(response);
            })
            .catch((error: any) => {
                onFailure(error);
            });
    });
    return { results, searchCriteria: filterCriteria, customfilterMap };
};


const getFleetExportToExcel = async (filterCriteria?: any, filterOrSortCriteria?: any, isFilter?: any, exportType?: string, filterOrSortMap?: any, customfilterexport?: any) => {
    let custFilter = "";
    const updatedFilter = customfilterexport ? customfilterexport.replace(/&/g, '%26'): '';

    if (filterOrSortMap === "filter") {
        custFilter = `?&$filter=${updatedFilter}`;
    } else if (filterOrSortMap === "sort") {
         custFilter = `?&$orderby=${updatedFilter}`;
    }
    let endPoint = SERVICEURI.getFleetExportToExcel + custFilter;
    filterCriteria.exportType = exportType;
    endPoint = AddFiltertoEndpoint(filterOrSortCriteria, endPoint, isFilter, updatedFilter);
    endPoint = helperfunctions.replaceSecondFilter(endPoint);

    try {
        const response = await postTelemetryApiInstance(endPoint, filterCriteria);
        return response;
    } catch (error) {
        throw error;
    }
};


const AddFiltertoEndpoint = (filterOrSortCriteria: any, endPoint: string, isFilter: any, custFilter: any) => {
    if (filterOrSortCriteria) {
        if (Array.isArray(filterOrSortCriteria) && filterOrSortCriteria?.length) {
            endPoint += `&$filter=`;
            filterOrSortCriteria.forEach((filter: any, index: number) => {
                const { operator, field, value } = filter.filters[0];
                switch (operator) {
                    case "contains":
                        if (field === "locName") {
                            endPoint += `contains(loc,'${value}')`;
                        } else {
                            endPoint += `contains(${field},'${value}')`;
                        }
                        break;
                    case "doesnotcontain":
                        endPoint += `contains(${field},'${value}') ne true`;
                        break;
                    case "isequalto":
                        endPoint += `${field} eq '${value}'`;
                        break;
                    case "eq":
                        if (["ikra", "smr", "wh", "ir", "fu"].includes(field)) {
                            if (field === "ikra") {
                                endPoint += `kwa eq ${value}`;
                            } else {
                                endPoint += `${field} eq ${value}`;
                            }
                        } else if (field === "lmdt") {
                            endPoint += `${field} eq ${moment(value).format("YYYY-MM-DD")}`;
                        } else {
                            endPoint += `${field} eq '${value}'`;
                        }
                        break;
                    default:
                        endPoint += `${field} ${operator} ${value}`;
                        break;
                }
                if (filterOrSortCriteria.length - 1 !== index) {
                    endPoint += " and ";
                }
            });
        } else if (custFilter) {
             
        } else {
            endPoint += isFilter ? "&$filter=" + filterOrSortCriteria : "&$orderby=" + filterOrSortCriteria;
        }
    }
    return endPoint;
};


const getFleetSuggestions = async (filterCriteria?: any) => {
    try {
        let endPoint = SERVICEURI.getFleetSuggestions;
        const response = await postTelemetryApiInstance(endPoint, filterCriteria);
        return response;
    } catch (error) {
        throw error;
    }
};

const getMyFleetDistributorMapData = async (data?: any) => {
    try {
        let endPoint = SERVICEURI.getFleetDistributorMapData;
        const response = await postFrameworkApiInstance(endPoint, data);
        return response;
    } catch (error) {
        throw error;
    }
};

const getDistributorDetail = async (data?: any) => {
    try {
        let endPoint = SERVICEURI.getDistributorDetail;
        const response = await postFrameworkApiInstance(endPoint, data);
        return response;
    } catch (error) {
        throw error;
    }
};


const getDistributorContacts = async (userAdId: any, distributorCode: any) => {
    try {
        let endPoint = SERVICEURI.getDistributorContacts.replace("{userAdId}", userAdId);
        endPoint = endPoint.replace("{distributor4Code}", distributorCode);

        const response = await getFrameworkApiInstance(endPoint);
        return response;
    } catch (error) {
        throw error;
    }
};

const getCustomerContacts = async (distributorCode: any, customerId: any) => {
    try {
        let endPoint = SERVICEURI.getCustomerContacts.replace("{distributor4Code}", distributorCode);
        endPoint = endPoint.replace("{customerId}", customerId);

        const response = await getFrameworkApiInstance(endPoint);
        return response;
    } catch (error) {
        throw error;
    }
};


const getGmapTimezone = async (lat: any, lng: any, timestamp: any, clientId: any) => {
    try {
        let endPoint = SERVICEURI.getGmapTimezone.replace("{latitude}", lat).replace("{longitude}", lng);
        endPoint += `&timestamp=${timestamp}&client=${clientId}`;

        const response = await fetch(endPoint);
        const responseJson = await response.json();

        if (responseJson?.timeZoneId) {
            return responseJson;
        } else {
            throw responseJson?.errorMessage;
        }
    } catch (error) {
        throw error;
    }
};


export default {
    getMyFleetGridData,
    getMyFleetTitleData,
    getMyFleetMapData,
    getInfoWindowData,
    getFleetExportToExcel,
    getFleetSuggestions,
    getMyFleetDistributorMapData,
    getDistributorDetail,
    getDistributorContacts,
    getCustomerContacts,
    getGmapTimezone
}
